/* angular:styles/component:css;bac42a59a3518136ab81d34e8a3cf808809ce692b88a0f1d91194a6edd2d9bcd;/src/src/app/shared/components/formly/form-field.wrapper.ts */
formly-field-ion-toggle,
formly-field-ion-checkbox,
formly-custom-select,
formly-input-serial-number,
formly-custom-select {
  width: 100%;
}
formly-field-ion-toggle,
ion-toggle {
  padding: 0 !important;
  margin: 0 !important;
  transform: none !important;
}
ion-toggle::part(label),
ion-checkbox::part(label),
ion-radio::part(label) {
  white-space: pre-wrap !important;
  flex: 1;
  margin-inline-end: 0 !important;
}
/*# sourceMappingURL=form-field.wrapper.css.map */
